// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.col-md-13 h6[data-v-531e1448]{\r\n  bottom: -30px;\n}\r\n", ""]);
// Exports
module.exports = exports;
